import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-success-icon',
  templateUrl: './success-icon.component.html',
})

export class SuccessIconComponent {
  @Input() color: string = '';
}
